export default __webpack_public_path__ + "static/media/img-egt-klm@2x.f9562049.png";